<template>
  <div class="loading-mask">
    
  </div>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<style scoped>
  .loading-mask {
    z-index: 7000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    background-color: #0004;
  }
</style>
